/*
 * Ophaalmoment + minimale bestelwaarde — Vuurwerk Outlet Emlichheim.
 *
 * Houdt de afrekenknop uit tot de klant een ophaaldag en tijdstip koos en de
 * minimale bestelwaarde gehaald is, en bewaart die keuze als cart-attribuut
 * (Ophaaldag / Ophaaltijd) zodat hij bij de bestelling in de admin staat.
 *
 * De winkelwagen van Horizon hertekent zichzelf na elke wijziging, dus na elke
 * DOM-mutatie wordt de staat opnieuw toegepast.
 */
(function () {
  if (window.__pickupGuardLoaded) return;
  window.__pickupGuardLoaded = true;

  var ROOT = '[data-pickup-guard]';
  var observer = null;
  var timer = null;

  function parseSlots(root) {
    try {
      return JSON.parse(root.getAttribute('data-slots') || '{}');
    } catch (e) {
      return {};
    }
  }

  function value(root, selector) {
    var el = root.querySelector(selector);
    return el ? el.value : '';
  }

  function fillTimes(root) {
    var daySelect = root.querySelector('[data-pickup-day]');
    var timeSelect = root.querySelector('[data-pickup-time]');
    if (!daySelect || !timeSelect) return;

    var day = daySelect.value;
    if (timeSelect.getAttribute('data-filled-for') === day) return;

    var slots = parseSlots(root);
    var list = slots[day] || [];
    var wanted = timeSelect.value || timeSelect.getAttribute('data-selected') || '';

    timeSelect.textContent = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = day ? 'Kies een tijdstip' : 'Kies eerst een dag';
    timeSelect.appendChild(placeholder);

    list.forEach(function (slot) {
      var option = document.createElement('option');
      option.value = slot;
      option.textContent = slot;
      if (slot === wanted) option.selected = true;
      timeSelect.appendChild(option);
    });

    timeSelect.setAttribute('data-filled-for', day);
    timeSelect.disabled = !day;
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/update.js';
  }

  function save(root) {
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          Ophaaldag: value(root, '[data-pickup-day]'),
          Ophaaltijd: value(root, '[data-pickup-time]')
        }
      })
    }).catch(function () {
      /* Een mislukte opslag mag de winkelwagen niet blokkeren; de volgende
         wijziging probeert het opnieuw. */
    });
  }

  function apply(root) {
    var day = value(root, '[data-pickup-day]');
    var time = value(root, '[data-pickup-time]');
    var total = parseInt(root.getAttribute('data-total') || '0', 10);
    var minimum = parseInt(root.getAttribute('data-minimum') || '0', 10);

    var belowMinimum = total < minimum;
    var slotMissing = !day || !time;
    var blocked = belowMinimum || slotMissing;

    var minMessage = root.querySelector('[data-pickup-msg-min]');
    var slotMessage = root.querySelector('[data-pickup-msg-slot]');
    if (minMessage) minMessage.hidden = !belowMinimum;
    if (slotMessage) slotMessage.hidden = belowMinimum || !slotMissing;

    var scope = root.parentElement || document;
    var ctas = scope.querySelector('.cart__ctas');
    if (!ctas) return;

    var button = ctas.querySelector('.cart__checkout-button');
    if (button) {
      if (blocked) {
        button.setAttribute('disabled', '');
        button.setAttribute('aria-disabled', 'true');
      } else if (total > 0) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    }

    // Shop Pay, Apple Pay en Google Pay springen rechtstreeks naar de checkout
    // en zouden de regels hierboven overslaan, dus die blijven weg zolang de
    // bestelling niet voldoet.
    var wallets = ctas.querySelector('.additional-checkout-buttons');
    if (wallets) {
      wallets.hidden = blocked;
      wallets.style.display = blocked ? 'none' : '';
    }
  }

  function refresh() {
    if (observer) observer.disconnect();
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      fillTimes(roots[i]);
      apply(roots[i]);
    }
    if (observer && document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest(ROOT);
    if (!root) return;

    if (target.matches('[data-pickup-day]')) {
      var timeSelect = root.querySelector('[data-pickup-time]');
      if (timeSelect) {
        timeSelect.setAttribute('data-selected', '');
        timeSelect.removeAttribute('data-filled-for');
      }
      fillTimes(root);
    }

    apply(root);
    save(root);
  });

  function start() {
    observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 80);
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
